<div class="container" [class.closed]="closed" [class.electron]="isElectron">
  <div class="header">
    <div>
      Chat
    </div>
    <div>
      <button (click)="newChatButton()" class="mr-2"><i class="fas fa-pencil"></i></button>
      <button (click)="close()"><i class="fas fa-times"></i></button>
    </div>
  </div>
  <div class="content">
    <div class="list">
      <app-chat-room-list (selectChatEvent)="selectChat($event)"></app-chat-room-list>
    </div>
    <div class="room">
      <app-chat-room [room]="selectedChat"></app-chat-room>
    </div>
  </div>
</div>

<p-dialog [(visible)]="createChatDialogVisible" [maximizable]="true"
          [style]="{width: '500px', height: '700px'}"
          [breakpoints]="{'1200px': '900px'}"
          appendTo="body" modal="true">
  <p-header>
    <span style="font-size: 1.5em;"><i class="fas fa-message"></i> New Chat Room</span>
  </p-header>
  <div>
    <h2>Add people to the chat room</h2>
    <app-field-wrapper labelsWidth="102px">
      <w-text-field label="Chat Name" [(value)]="newChatRoomName"></w-text-field>
      <div *ngFor="let invitation of chatInvitations; index as i" class="invitation-row">
        <w-worker-field [label]="'Invite #' + (i + 1).toString()" [user]="chatInvitations[i]" (valueChange)="setInvitation($event, i)" ></w-worker-field>
        <button (click)="removeInvitation(i)" class="p-button-danger p-button-small mr-2" [disabled]="chatInvitations.length === 1">Remove</button>
      </div>
    </app-field-wrapper>
    <button (click)="addInvitation()" class="p-button-success p-button-small mr-2" [disabled]="!canAddInvite">Add</button>
  </div>
  <p-footer>
    <button (click)="createChat()" class="p-button-success p-button-small" [disabled]="!canCreateChat">Create</button>
    <button (click)="createChatDialogVisible = false" class="p-button-secondary p-button-small">Cancel</button>
  </p-footer>
</p-dialog>
